import ApiService from "@/core/services/ApiService";

class AuditoryService {

    public static getData(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/auditory', data)
    }

}

export default AuditoryService;